import { render } from "./StorefrontSummary.vue?vue&type=template&id=6df142c6"
import script from "./StorefrontSummary.vue?vue&type=script&lang=js"
export * from "./StorefrontSummary.vue?vue&type=script&lang=js"

import "./StorefrontSummary.vue?vue&type=style&index=0&id=6df142c6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__